import * as types from "./actionTypes";

export const setCentralLoader = (payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_CENTRAL_LOADER,
      payload,
    });
  };
};
